import { Inject, Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject } from 'rxjs';
import { BreadCrumb } from '../../../components/breadcrumb/breadcrumb.types';

@Injectable()
export class NotificationService {
    constructor(@Inject(Injector) private injector: Injector) {}

    private breadCrumbSource = new BehaviorSubject<BreadCrumb[]>(new Array<BreadCrumb>());
    currentBreadCrumbSource = this.breadCrumbSource.asObservable();

    publishBreadCrumb(key: string, route: Router) {
        let breadcrumb: BreadCrumb = {
            label: '',
            labelParam: key,
            params: null,
            url: route.url,
            active: false,
        };

        this.breadCrumbSource.next(new Array<BreadCrumb>(breadcrumb));
    }

    private get toastrService(): ToastrService {
        return this.injector.get(ToastrService);
    }

    addErrorMessage(msg: string) {
        if (!msg) {
            msg = 'Se ha producido un error';
        }

        //Todo:agaro. Posibilidad a través de concatenar mensajes con dos ';' de lanzar varios avisos. 12/12/2019
        if (msg.includes(';;')) {
            let mensajes = msg.split(';;', 3);

            for (let currentMsg of mensajes) {
                this.toastrService.error(currentMsg, 'Error', {
                    closeButton: true,
                    timeOut: 7000, // 7 segundos
                    onActivateTick: true,
                });
            }
        } else {
            //Como siempre, lanzando solo uno:
            this.toastrService.error(msg, 'Error', {
                disableTimeOut: false,
                timeOut: 15000, // 15 segundos
                closeButton: true,
                onActivateTick: true,
            });
        }

        console.log('cexveg error:-> ' + msg);
    }

    addInfoMessage(msg: string) {
        this.toastrService.info(msg, 'Info', {
            closeButton: true,
            timeOut: 5000, // 5 sg.
            onActivateTick: true,
        });
    }

    addWarningMessage(msg: string) {
        this.toastrService.warning(msg, 'Advertencia', {
            closeButton: true,
            timeOut: 5000, // 5 sg.
            onActivateTick: true,
        });
    }

    addSuccessMessage(msg: string) {
        this.toastrService.success(msg, 'Éxito', {
            closeButton: true,
            timeOut: 5000, // 5 sg.
            onActivateTick: true,
        });
    }
}
